module.exports = __webpack_public_path__ + "static/img/index-pro-全民营销.569af164.png";